module.exports = __webpack_public_path__ + "img/21.569fcc7c.jpg";